import { PayloadModel } from "../types/PayloadModel";
import { TranslationModel } from "../types/TranslationModel";
import { UnemploymentInsuranceOptionModel } from "../types/UnemploymentInsuranceOptionModel";
import { UnionOptionModel } from "../types/UnionOptionModel";
import axios from "axios";
import { ContactLeadModel } from "../types/ContactLeadModel";
import { EmailValidationResponse } from "../types/EmailValidationResponse";
import { AddressLookupResponse } from "../types/AddressLookupResponse";
import { ChildrenEnrollmentPayload } from "../types/ChildrenEnrollmentPayload";
import { PartnerInviteRequest } from "../types/PartnerInviteRequest";
import { RatingRequest } from "../types/RatingRequest";
import { TrackTraceResponseModel } from "../types/TrackTraceResponseModel";
import { TrackTraceUnionRequestModel } from "../types/TrackTraceUnionRequestModel";
import { TrackTraceSalaryInsuranceRequestModel } from "../types/TrackTraceSalaryInsuranceRequestModel";
import { GiftCardResponse } from "../types/GiftCardResponse";
import { GiftCardStatusResponse } from "../types/GiftCardStatusResponse";
import { SalaryInsuranceRequestModel } from "../types/SalaryInsuranceRequestModel";
import { BloomreachLeadModel } from "../types/BloomreachLeadModal";
import { SalaryinsuranceCalculatorPricing } from "../types/SalaryinsuranceCalculatorPricing";
import { SalaryInsuranceLeadModel } from "../types/SalaryInsuranceLeadModel";
import { SalaryCheckRequestModel } from "../types/SalaryCheckRequest";
import { JobTitleItem } from "../features/SalaryCheck/components/desktop-step-wizard";
import { SalaryCheckResponse } from "../types/SalaryCheckResponse";
import { BloomreachAnalysisLeadModel } from "../types/BloomreachAnalysisLeadModel";
import { BloomreachPreAnalysisLeadModel } from "../types/BloomreachPreAnalysisLeadModel";
import { BloomreachCatalogItem } from "../types/BloomreachCatalogItem";
import { BloomreachLogbuyOfferResponse } from "../types/BloomreachLogbuyOfferResponse";

export const fetchSignupDate = async (payload: PayloadModel) => {
  return axios.post("/api/oi/getsignupdate", {
    ...payload,
  });
};

export const getOffersFromLogbuy = async (take: number) => {
  return axios.get<{ offers: BloomreachLogbuyOfferResponse[] }>(`/api/bloomreach/getlogbuyoffers?take=${take}`);
}

export const postAllowContact = async (payload: ContactLeadModel) => {
  return axios.post("/api/oi/submit", {
    ...payload,
  });
};

export const postBloomreachLead = async (payload: BloomreachLeadModel) => {
  return axios.post("/api/bloomreach/submitlead", {
    ...payload,
  });
};

export const postBloomreachAnalysisLead = async (payload: BloomreachAnalysisLeadModel) => {
  return axios.post("/api/bloomreach/submitanalysis", {
    ...payload,
  });
};

export const postBloomreachPreAnalysisLead = async (payload: BloomreachPreAnalysisLeadModel) => {
  return axios.post("/api/bloomreach/submitpreanalysis", {
    ...payload,
  });
};

export const fetchBloomreachCatalogItem= async (profile: string, situation: string) => {
  return axios.get<BloomreachCatalogItem>(`/api/bloomreach/getanalysiscatalogitem?profile=${profile}&situation=${situation}`);
};

export const postEnrollment = async (payload: PayloadModel) => {
  return axios.post<{ url: string }>("/api/oi/submit", {
    ...payload,
  });
};

export const postChildrenEnrollment = async (payload: ChildrenEnrollmentPayload) => {
  return axios.post("/api/oi/submitchildren", {
    ...payload,
  });
};

export const fetchTranslations = async (url?: string) => {
  return axios.get<TranslationModel>(url || "/assets/data/translations.json");
};

export const fetchSalaryInsuranceData = async (url?: string) => {
  return axios.get<SalaryinsuranceCalculatorPricing[]>(url || "/media/vildlcfv/ase_loensikring_json_01_04_2026-1.json");
};

export const fetchUnionOptions = async () => {
  return axios.get<UnionOptionModel[]>("/assets/data/unions.json");
};

export const fetchUnemploymentInsuranceOptions = async () => {
  return axios.get<UnemploymentInsuranceOptionModel[]>("/assets/data/unemploymentinsurancefunds.json");
};

export const postEmailValidation = async (email: string) => {
  return axios.post<EmailValidationResponse>("/api/oi/validateemail", {
    email,
    source: "enroll member",
  });
};

export const lookupAddress = async (address: string, caretpos: string, startFrom?: string, addressId?: string) => {
  let query = `?q=${address}&type=adresse&caretpos=${caretpos}&supplerendebynavn=true&stormodtagerpostnumre=true&multilinje=true&fuzzy=`;

  if (startFrom) {
    query += `&startfra=${startFrom}`;
  }

  if (addressId) {
    query += `&adgangsadresseid=${addressId}`;
  }

  return axios.get<AddressLookupResponse[]>(`https://api.dataforsyningen.dk/autocomplete${query}`);
};

export const submitPartnerInvite = async (payload: PartnerInviteRequest) => {
  return axios.post("/api/oi/submitpartnerinvite", {
    ...payload,
  });
};

export const postRating = async (payload: RatingRequest) => {
  return axios.post("/api/oi/rating", {
    ...payload,
  });
};

export const getTrackAndTraceEvents = async (id: string) => {
  return axios.get<TrackTraceResponseModel>(`/api/oi/gettrackandtrace?id=${id}`);
};

export const postTrackAndTraceBuyUnion = async (payload: TrackTraceUnionRequestModel) => {
  return axios.post("/api/oi/trackandtracebuyunion", {
    ...payload,
  });
};

export const postTrackAndTraceBuySalaryInsurance = async (payload: TrackTraceSalaryInsuranceRequestModel) => {
  return axios.post("/api/oi/addsaleryinsurance", {
    ...payload,
  });
};

export const fetchGiftCard = async (occupation: "Employee" | "Unemployed" | "SelfEmployed" | "Student" | undefined, front: boolean, source: string) => {
  return axios.get<GiftCardResponse>(`/api/giftcard/checkforgiftcard?target=${occupation?.toLocaleLowerCase()}&front=${front}&source=${source}`);
};

export const fetchGiftCardProducts = async (occupation: "Employee" | "Unemployed" | "SelfEmployed" | "Student" | undefined, products: string, source: string) => {
  return axios.get<GiftCardResponse>(`/api/giftcard/checkforgiftcard?target=${occupation?.toLocaleLowerCase()}&products=${products}&source=${source}`);
};

export const fetchGiftCardStatus = async (guid: string) => {
  return axios.get<GiftCardStatusResponse>(`/api/giftcard/getgiftcardsleft?giftcardid=${guid}`);
};

export const postSalaryInsuranceData = async (payload: SalaryInsuranceRequestModel) => {
  return axios.post(`/umbraco/api/SalaryCalculatorApi/PostSalCalCampaign2021`, payload);
};

export const postSalaryInsuranceLeadData = async (payload: SalaryInsuranceLeadModel) => {
  return axios.post(`/umbraco/api/SalaryCalculatorApi/PostSalCalCampaign2026`, payload);
};

export const fetchDiscountStatus = async (code: string) => {
  return axios.get(`/api/oi/checkDiscount?discountCode=${code}`);
};

export const fetchSalaryCheckData = async (infoKey: string) => {
  return axios.get(`/umbraco/api/JobsApi/GetSalaryCalculation?infoKey=${infoKey}`);
};

export const postSalaryCalculation = async (payload: SalaryCheckRequestModel) => {
  return axios.post<SalaryCheckResponse>(`/umbraco/api/JobsApi/CalculateSalary`, payload);
};

export const postJobtitles = async (query: any) => {
  return axios.post(`/umbraco/api/JobsApi/SearchJobTitles`, query, { headers: { "Content-Type": "application/json" } }
);
}